import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
import { DateTimeShapeValues } from "@cmodules/checklist/assets/data/constants/date-time-shapes-values"
import { IScoring } from "./asset"
import { SimpleRuleItem } from "../simple-rule"
import _ from 'lodash'

export type DefaultValueType = 'current' | 'future'
export type PeriodType = 'day' | 'week' | 'month' | 'year'

export interface DateTimeDefaultValue {
  /**
   * *** ### All these types is not optional
   * If hidden then this is mandatory
   * type_object is not right should be fixed and removed
   * */
  type?: DefaultValueType
  period?: number
  period_type?: PeriodType
}

export type TDateTimeShape = typeof DateTimeShapeValues[number]['value'];

export class DateTimeOptionsVM extends CommonOptionVM {
  future_date?: boolean
  prior_date?: boolean
  date?: boolean
  time?: boolean
  required?: boolean
  require_media?: boolean
  require_note?: boolean
  simple_rule?: SimpleRuleItem[]

  enable_score?: boolean
  scoring?: IScoring
  /**
   * *** ### (remove null) and add real types
   * */
  date_time_shape?: TDateTimeShape | null
  default_value?: DateTimeDefaultValue

  constructor(data: Partial<DateTimeOptionsVM> = {}) {
    super(data)
    this.future_date = data?.future_date || undefined
    this.prior_date = data?.prior_date || undefined
    this.required = data?.required || undefined
    this.require_media = data?.require_media || undefined
    this.require_note = data?.require_note || undefined
    this.enable_score = data.enable_score ?? undefined

    this.simple_rule = data.simple_rule ? _.map(data.simple_rule, x => new SimpleRuleItem(x as any)) : undefined

    this.scoring = this.enable_score ? {
      min_point: this.scoring?.min_point ?? 0,
      max_point: this.scoring?.max_point ?? null,
      scoring_weight: this.scoring?.scoring_weight ?? 1
    } : undefined

    /**
     * *** ### heck date_time_shape then insert these
     * */
    this.date = data?.date ?? undefined
    this.time = data?.time ?? undefined
    this.date_time_shape = data?.date_time_shape || undefined
    this.default_value = data?.default_value ? {
      /**
       * *** ### these types is not optional
       * */
      type: data?.default_value?.type || undefined,
      period: data?.default_value?.period || undefined,
      period_type: data?.default_value?.period_type
    } : undefined
  }

  validateData() {
    const errors: any[] = []

    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default DateTimeOptionsVM